export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-4">
            联系我们
          </h2>
          <p className="text-foreground-500 text-sm mb-10">意见反馈 · 内容推荐 · 商务合作</p>

          <div className="bg-background-100 rounded-2xl p-8 md:p-10">
            <div className="w-16 h-16 mx-auto mb-6 rounded-2xl bg-primary-500/10 flex items-center justify-center">
              <i className="ri-mail-send-line text-3xl text-primary-500 w-8 h-8 flex items-center justify-center"></i>
            </div>
            <h3 className="text-xl font-heading text-foreground-950 mb-4">欢迎联系我们</h3>
            <p className="text-foreground-600 text-sm leading-relaxed mb-8 max-w-md mx-auto">
              如果您有影片推荐、内容建议或商务合作需求，欢迎通过以下方式联系我们。我们重视每一位用户的反馈，期待与您一起打造更好的<strong>91电影免费看</strong>平台。
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
              <a
                href="mailto:contact@91movie.example.com"
                className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-50 font-medium rounded-full hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer text-sm"
              >
                <i className="ri-mail-line w-4 h-4 flex items-center justify-center"></i>
                发送邮件
              </a>
              <a
                href="#hero"
                className="inline-flex items-center gap-2 px-6 py-3 border border-foreground-300 text-foreground-700 font-medium rounded-full hover:border-primary-500 hover:text-primary-500 transition-colors whitespace-nowrap cursor-pointer text-sm"
              >
                <i className="ri-message-2-line w-4 h-4 flex items-center justify-center"></i>
                在线留言
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}